/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOdometerLow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 8a8 8 0 0 0-8 8H2C2 10.477 6.477 6 12 6s10 4.477 10 10h-2a8 8 0 0 0-8-8zm-2.536 6.12a3.001 3.001 0 1 0 1.414-1.413l-2.242-2.243-1.414 1.415zm3.415.587a1 1 0 1 1-1.415 1.414 1 1 0 0 1 1.415-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOdometerLow as OdometerLow };
